export const ADD_ALL_CLIENT_WINES_REQUEST = 'ADD_ALL_CLIENT_WINES_REQUEST';
export const ADD_ALL_CLIENT_WINES_SUCCESS = 'ADD_ALL_CLIENT_WINES_SUCCESS';
export const ADD_ALL_CLIENT_WINES_ERROR = 'ADD_ALL_CLIENT_WINES_ERROR';

export const GET_WINES_REQUEST = 'GET_WINES_REQUEST';
export const GET_WINES_SUCCESS = 'GET_WINES_SUCCESS';
export const GET_WINES_ERROR = 'GET_WINES_ERROR';

export const GET_ALL_CLIENT_WINES_REQUEST = 'GET_ALL_CLIENT_WINES_REQUEST';
export const GET_ALL_CLIENT_WINES_SUCCESS = 'GET_ALL_CLIENT_WINES_SUCCESS';
export const GET_ALL_CLIENT_WINES_ERROR = 'GET_ALL_CLIENT_WINES_ERROR';
